var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoclass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 201,
    viewBox: "0 0 256 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "currentIllo",
    clipPath: "url(#clip0_2852_40694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M231.608 1.06055H1.07812V148.702H231.608V1.06055Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M225.01 19.5791H7.66406V139.968H225.01V19.5791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M231.514 0.929688H0.984375V10.7234H231.514V0.929688Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.25269 7.75246C9.2552 7.75246 10.0679 6.93977 10.0679 5.93726C10.0679 4.93476 9.2552 4.12207 8.25269 4.12207C7.25019 4.12207 6.4375 4.93476 6.4375 5.93726C6.4375 6.93977 7.25019 7.75246 8.25269 7.75246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.1511 7.75246C16.1536 7.75246 16.9663 6.93977 16.9663 5.93726C16.9663 4.93476 16.1536 4.12207 15.1511 4.12207C14.1486 4.12207 13.3359 4.93476 13.3359 5.93726C13.3359 6.93977 14.1486 7.75246 15.1511 7.75246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.0339 7.75246C23.0364 7.75246 23.8491 6.93977 23.8491 5.93726C23.8491 4.93476 23.0364 4.12207 22.0339 4.12207C21.0314 4.12207 20.2188 4.93476 20.2188 5.93726C20.2188 6.93977 21.0314 7.75246 22.0339 7.75246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M83.2695 32.0693H27.4219V127.476H83.2695V32.0693Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M139.454 32.0693H92.9141V58.331H139.454V32.0693Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M139.454 65.6436H92.9141V93.8998H139.454V65.6436Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M139.454 101.214H92.9141V127.476H139.454V101.214Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M205.269 32.0693H149.422V73.6469H205.269V32.0693Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M205.269 85.8975H149.422V127.475H205.269V85.8975Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M183.75 76.6339V67.6829C183.75 64.5018 185.014 61.4509 187.263 59.2016C189.512 56.9522 192.563 55.6885 195.744 55.6885C198.926 55.6885 201.976 56.9522 204.226 59.2016C206.475 61.4509 207.739 64.5018 207.739 67.6829V76.6339C207.738 77.0611 207.568 77.4706 207.266 77.7727C206.964 78.0747 206.555 78.2446 206.128 78.2451H185.361C184.934 78.2446 184.524 78.0747 184.222 77.7727C183.92 77.4706 183.75 77.0611 183.75 76.6339Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M213.479 193.122L209.248 194.293L202.719 178.533L208.963 176.805L213.479 193.122Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M205.895 193.919L214.054 191.661L215.475 196.798L202.179 200.478C201.993 199.803 201.941 199.098 202.026 198.404C202.112 197.709 202.334 197.038 202.679 196.429C203.024 195.82 203.485 195.285 204.037 194.854C204.589 194.424 205.22 194.106 205.895 193.919Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M169.376 196.375H164.987L162.898 179.444H169.377L169.376 196.375Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M161.861 195.12H170.327V200.45H156.531C156.531 199.75 156.669 199.057 156.937 198.411C157.205 197.764 157.597 197.176 158.092 196.681C158.587 196.186 159.175 195.794 159.822 195.526C160.468 195.258 161.161 195.12 161.861 195.12Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M164.085 101.753C164.398 102.176 164.8 102.525 165.263 102.776C165.726 103.027 166.238 103.173 166.763 103.204C167.289 103.236 167.815 103.151 168.304 102.957C168.793 102.763 169.234 102.465 169.596 102.082L181.264 107.33L180.203 100.767L169.285 96.7891C168.602 96.2247 167.735 95.9305 166.849 95.9623C165.964 95.9941 165.121 96.3496 164.48 96.9615C163.839 97.5734 163.444 98.3992 163.372 99.2824C163.299 100.166 163.552 101.045 164.085 101.753Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M188.333 141.223C184.667 141.223 180.872 140.677 177.682 139.053C175.989 138.208 174.488 137.022 173.274 135.571C172.059 134.119 171.158 132.432 170.625 130.616C168.963 125.353 171.059 120.182 173.086 115.182C174.341 112.084 175.528 109.158 175.835 106.273L175.943 105.249C176.422 100.649 176.836 96.6761 179.128 95.186C180.317 94.4137 181.914 94.3696 184.012 95.0511L203.721 101.453L202.996 138.865L202.876 138.905C202.773 138.94 195.826 141.223 188.333 141.223Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M183.658 83.4043C183.658 83.4043 193.325 80.5399 200.844 81.6141C200.844 81.6141 196.547 105.245 197.98 113.122C199.412 120.999 173.096 116.165 178.466 108.646L180.256 99.6952C180.256 99.6952 176.676 96.1148 179.898 91.8183L183.658 83.4043Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M178.914 140.515L167 138.281L171.16 106.269C171.439 105.376 177.883 85.0936 180.809 83.9963C182.934 83.248 185.107 82.6443 187.314 82.1893L187.738 82.1045L185.349 85.6881L175.837 108.479L178.914 140.515Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M172.706 192.453L157.312 189.887L165.951 154.612L178.806 106.37L178.933 107.227C178.943 107.291 180.144 113.593 197.963 110.796L198.12 110.772L198.163 110.924L219.7 187.022L202.16 189.945L186.161 134.425L172.706 192.453Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M194.039 146.504L194.049 146.233C194.059 145.932 195.118 116.024 194.765 103.996C194.41 91.9265 198.317 81.4746 198.357 81.3704L198.389 81.2865L198.475 81.2617C203.53 79.8174 207.916 84.1279 207.96 84.1716L208.021 84.2332L206.582 96.1117L212.746 139.306L194.039 146.504Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M193.278 78.036C198.135 78.036 202.072 74.0988 202.072 69.2421C202.072 64.3854 198.135 60.4482 193.278 60.4482C188.422 60.4482 184.484 64.3854 184.484 69.2421C184.484 74.0988 188.422 78.036 193.278 78.036Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M180.914 68.3992C180.917 65.8837 181.917 63.472 183.696 61.6933C185.475 59.9145 187.887 58.914 190.402 58.9111H192.192C194.708 58.914 197.12 59.9145 198.898 61.6933C200.677 63.472 201.678 65.8837 201.68 68.3992V68.5783H197.897L196.607 64.965L196.349 68.5783H194.394L193.742 66.7552L193.612 68.5783H180.914V68.3992Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M192.42 79.2513C192.242 79.0108 192.136 78.725 192.114 78.4269C192.091 78.1287 192.154 77.8303 192.294 77.566C194.191 73.9576 196.847 67.2902 193.321 63.1783L193.068 62.8828H203.303V78.2499L194.005 79.8905C193.911 79.9071 193.816 79.9156 193.72 79.9157C193.466 79.9156 193.216 79.8554 192.99 79.7399C192.764 79.6245 192.569 79.457 192.42 79.2513Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M151.206 15.8052C144.044 9.76155 135.28 5.92997 125.979 4.77668C116.679 3.62339 107.244 5.19812 98.8229 9.30925C90.4013 13.4204 83.3563 19.8906 78.545 27.9327C73.7337 35.9748 71.3636 45.2419 71.7231 54.6064C72.0826 63.971 75.1562 73.0291 80.5699 80.6786C85.9836 88.3282 93.504 94.2393 102.216 97.6926C110.928 101.146 120.456 101.993 129.64 100.13C138.825 98.2669 147.269 93.7747 153.947 87.1997L213.245 137.235C214.148 137.998 215.316 138.371 216.493 138.273C217.671 138.174 218.761 137.612 219.524 136.71C220.286 135.807 220.659 134.639 220.561 133.462C220.462 132.284 219.9 131.194 218.998 130.431L218.991 130.426L159.693 80.3904C166.582 70.5038 169.53 58.401 167.96 46.4539C166.39 34.5068 160.415 23.5766 151.206 15.8052ZM147.384 75.5723C142.764 81.0471 136.625 85.029 129.742 87.0146C122.859 89.0003 115.543 88.9003 108.717 86.7275C101.891 84.5546 95.8625 80.4065 91.3941 74.8076C86.9257 69.2087 84.218 62.4105 83.6133 55.2727C83.0086 48.1349 84.5341 40.978 87.9968 34.7072C91.4596 28.4364 96.7041 23.3332 103.067 20.043C109.43 16.7528 116.626 15.4233 123.745 16.2228C130.863 17.0222 137.585 19.9146 143.06 24.5342C146.695 27.6015 149.69 31.3547 151.875 35.5796C154.06 39.8045 155.391 44.4184 155.792 49.1577C156.194 53.897 155.658 58.669 154.215 63.2013C152.772 67.7335 150.451 71.9372 147.384 75.5723Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    opacity: 0.3,
    d: "M96.3483 79.8958C89.4001 74.0324 84.9111 65.7704 83.7725 56.7505C82.6339 47.7305 84.9291 38.6121 90.2023 31.2061C89.5098 31.9035 88.8404 32.6339 88.1939 33.3972C85.1266 37.0324 82.8053 41.236 81.3626 45.7683C79.9199 50.3005 79.384 55.0725 79.7855 59.8118C80.187 64.5511 81.5181 69.165 83.7027 73.3899C85.8873 77.6148 88.8827 81.3681 92.5178 84.4354C96.153 87.5027 100.357 89.8239 104.889 91.2666C109.421 92.7094 114.193 93.2453 118.932 92.8438C123.672 92.4422 128.286 91.1112 132.51 88.9266C136.735 86.742 140.489 83.7466 143.556 80.1115C144.201 79.3471 144.808 78.5643 145.378 77.7631C138.965 84.2071 130.362 88.0035 121.279 88.3986C112.196 88.7937 103.297 85.7586 96.3483 79.8958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M196.111 117.128C196.622 117.253 197.155 117.264 197.671 117.161C198.187 117.058 198.675 116.843 199.099 116.531C199.523 116.219 199.873 115.818 200.126 115.357C200.378 114.895 200.526 114.383 200.559 113.858L212.888 110.436L207.876 106.066L196.937 109.986C196.051 109.988 195.197 110.316 194.536 110.907C193.875 111.497 193.454 112.309 193.352 113.19C193.25 114.07 193.475 114.957 193.983 115.683C194.492 116.409 195.249 116.923 196.111 117.128Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M201.227 115.317L200.477 108.19L210.775 102.508L204.061 94.3802L205.156 85.2503L207.884 84.0811L207.969 84.1901C209.256 85.8443 220.538 100.403 220.538 102.202C220.538 104.051 218.38 109.479 215.427 110.955C212.578 112.38 201.882 115.148 201.428 115.265L201.227 115.317Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M254.663 200.93H118.249C118.154 200.93 118.063 200.892 117.995 200.825C117.928 200.758 117.891 200.667 117.891 200.572C117.891 200.477 117.928 200.386 117.995 200.319C118.063 200.252 118.154 200.214 118.249 200.214H254.663C254.758 200.214 254.849 200.252 254.916 200.319C254.983 200.386 255.021 200.477 255.021 200.572C255.021 200.667 254.983 200.758 254.916 200.825C254.849 200.892 254.758 200.93 254.663 200.93Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2852_40694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 254.042,
    height: 200,
    fill: "white",
    transform: "translate(0.976562 0.929688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoclass);
export default __webpack_public_path__ + "static/media/noclass.377162a56208c5c44b12e14ece579d7e.svg";
export { ForwardRef as ReactComponent };